import axios from '../Api/api';

export default function cert() {
    return new Promise((resolve, reject) => {
        axios.get("home/getCert", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
